// Mirrari Clinic shared constants
export const CLINIC = {
    name: "Mirrari Clinic",
    tagline: "Revitalizing Skin. Perfecting Smiles.",
    phone: "+91 7808407407",
    phoneRaw: "7808407407",
    whatsappNumber: "917808407407",
    hours: "11:00 AM – 9:00 PM",
    address:
        "1st Floor, besides Poonam Electronics, above Khandelwal Cement, opposite Usmania Masjid, Wadali Naka, Amravati, Maharashtra 444606",
    shortAddress: "Wadali Naka, Amravati, Maharashtra 444606",
    email: "hello@mirrariclinics.com",
    mapsEmbed:
        "https://www.google.com/maps?q=Wadali+Naka+Amravati+Maharashtra+444606&output=embed",
    mapsLink:
        "https://www.google.com/maps/search/?api=1&query=Mirrari+Clinic+Wadali+Naka+Amravati",
};

export const whatsappLink = (
    message = "Hello Mirrari Clinic, I'd like to book an appointment.",
) =>
    `https://wa.me/${CLINIC.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const mailtoLink = (
    subject = "Appointment Inquiry",
    body = "Hello Mirrari Clinic team, I would like to schedule an appointment.",
) =>
    `mailto:${CLINIC.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
